var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ]
    },
    [
      _c("DeleteDialog", {
        attrs: {
          title: "Löschen",
          text: "Willst du diesen Sektor wirklich löschen?",
          deleteMode: _vm.deleteMode,
          confirmCallback: _vm.deleteConfirmCallback
        }
      }),
      _vm._v(" "),
      _c("FieldForm", {
        attrs: {
          formVisible: _vm.showFieldForm,
          submitFormCallback: _vm.fieldSubmitFormCallback
        }
      }),
      _vm._v(" "),
      _c("Breadcrumb"),
      _vm._v(" "),
      _c("el-card", { attrs: { shadow: "always" } }, [
        _c(
          "div",
          {
            staticClass: "clearfix",
            attrs: { slot: "header" },
            slot: "header"
          },
          [
            _c("span", [_vm._v("Gebäude Details")]),
            _vm._v(" "),
            _vm.createMode
              ? _c(
                  "el-button",
                  {
                    staticStyle: { float: "right", padding: "3px 0" },
                    attrs: { type: "text" },
                    on: {
                      click: function($event) {
                        _vm.createMode = !_vm.createMode
                      }
                    }
                  },
                  [_vm._v("Schliessen")]
                )
              : _vm.user_is_admin
              ? _c(
                  "el-button",
                  {
                    staticStyle: { float: "right", padding: "3px 0" },
                    attrs: { type: "text" },
                    on: {
                      click: function($event) {
                        _vm.editMode = !_vm.editMode
                      }
                    }
                  },
                  [_vm._v("Bearbeiten")]
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _vm.editMode || _vm.createMode
          ? _c(
              "div",
              [
                _c(
                  "el-form",
                  {
                    ref: "building",
                    attrs: {
                      model: _vm.building,
                      rules: _vm.rules,
                      "label-position": "top"
                    }
                  },
                  [
                    _vm.user_is_admin
                      ? _c(
                          "el-row",
                          { attrs: { gutter: 5 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { span: 16 } },
                              [
                                _c(
                                  "el-form-item",
                                  {
                                    attrs: {
                                      label: "Supplier auswählen",
                                      prop: "supplier"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "Supplier auswählen",
                                          remote: "",
                                          "default-first-option": ""
                                        },
                                        model: {
                                          value: _vm.building.supplier,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.building,
                                              "supplier",
                                              $$v
                                            )
                                          },
                                          expression: "building.supplier"
                                        }
                                      },
                                      _vm._l(_vm.get_suppliers, function(
                                        supplier
                                      ) {
                                        return _c("el-option", {
                                          key: supplier.id,
                                          attrs: {
                                            label: supplier.supplier_name,
                                            value: supplier
                                          }
                                        })
                                      }),
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 5 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 16 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Strasse", prop: "street" } },
                              [
                                _c("el-input", {
                                  attrs: { "auto-complete": "off" },
                                  model: {
                                    value: _vm.building.street,
                                    callback: function($$v) {
                                      _vm.$set(_vm.building, "street", $$v)
                                    },
                                    expression: "building.street"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { prop: "house_number", label: "Nummer" }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    "auto-complete": "off",
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.building.house_number,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.building,
                                        "house_number",
                                        $$v
                                      )
                                    },
                                    expression: "building.house_number"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 3 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "Suffix" } },
                              [
                                _c("el-input", {
                                  attrs: { "auto-complete": "off" },
                                  model: {
                                    value: _vm.building.suffix,
                                    callback: function($$v) {
                                      _vm.$set(_vm.building, "suffix", $$v)
                                    },
                                    expression: "building.suffix"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 5 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "Gebäude Bild", prop: "image" }
                              },
                              [
                                _c(
                                  "el-upload",
                                  {
                                    staticClass: "upload-demo",
                                    attrs: {
                                      action: "",
                                      "show-file-list": true,
                                      "file-list": _vm.buildingImageFileList,
                                      "auto-upload": false,
                                      "on-change": _vm.onChangeBuildingImage,
                                      "on-remove": _vm.onRemoveBuildingImage,
                                      "list-type": "picture"
                                    }
                                  },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "small",
                                          type: "primary"
                                        }
                                      },
                                      [_vm._v("Hochladen")]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4, offset: 2 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Gebäudebreite",
                                  prop: "building_width"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    "auto-complete": "off",
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.building.building_width,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.building,
                                        "building_width",
                                        $$v
                                      )
                                    },
                                    expression: "building.building_width"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Y-Position des Gebäudes",
                                  prop: "fields_top_position"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    "auto-complete": "off",
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.building.fields_top_position,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.building,
                                        "fields_top_position",
                                        $$v
                                      )
                                    },
                                    expression: "building.fields_top_position"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "X-Position des Gebäudes",
                                  prop: "fields_left_position"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    "auto-complete": "off",
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.building.fields_left_position,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.building,
                                        "fields_left_position",
                                        $$v
                                      )
                                    },
                                    expression: "building.fields_left_position"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "Sektorbreite",
                                  prop: "field_width"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    "auto-complete": "off",
                                    type: "number"
                                  },
                                  model: {
                                    value: _vm.building.field_width,
                                    callback: function($$v) {
                                      _vm.$set(_vm.building, "field_width", $$v)
                                    },
                                    expression: "building.field_width"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 5 } },
                      [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    "Globale Bezeichnung mit dem Schlüssel «step1_text» überschreiben",
                                  prop: "building_step1_text"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { "auto-complete": "off" },
                                  model: {
                                    value: _vm.building.building_step1_text,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.building,
                                        "building_step1_text",
                                        $$v
                                      )
                                    },
                                    expression: "building.building_step1_text"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 5 } },
                      [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    "Globale Bezeichnung mit dem Schlüssel «order_mail_body» überschreiben",
                                  prop: "building_order_mail_body"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { "auto-complete": "off" },
                                  model: {
                                    value:
                                      _vm.building.building_order_mail_body,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.building,
                                        "building_order_mail_body",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "building.building_order_mail_body"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 5 } },
                      [
                        _c(
                          "el-col",
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label:
                                    "Globale Bezeichnung mit dem Schlüssel «order_gift_mail_body» überschreiben",
                                  prop: "building_order_gift_mail_body"
                                }
                              },
                              [
                                _c("el-input", {
                                  attrs: { "auto-complete": "off" },
                                  model: {
                                    value:
                                      _vm.building
                                        .building_order_gift_mail_body,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.building,
                                        "building_order_gift_mail_body",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "building.building_order_gift_mail_body"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function($event) {
                                return _vm.submitForm("building")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                        Speichern\n                        "
                            ),
                            _vm.formSubmitted
                              ? _c("i", { staticClass: "el-icon-loading" })
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("el-button", { on: { click: _vm.cancelForm } }, [
                          _vm._v("Abbrechen")
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _c(
              "div",
              { staticClass: "building-details" },
              [
                _c(
                  "el-row",
                  [
                    _c("el-col", { attrs: { span: 16 } }, [
                      _c("p", [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("Supplier")
                        ]),
                        _vm._v(
                          ":\n                        " +
                            _vm._s(
                              _vm.building.supplier
                                ? _vm.building.supplier.supplier_name
                                : ""
                            )
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", [
                      _c("p", [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("Adresse")
                        ]),
                        _vm._v(
                          ": " +
                            _vm._s(_vm.building.street) +
                            " " +
                            _vm._s(_vm.building.house_number) +
                            "\n                        " +
                            _vm._s(_vm.building.suffix)
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-row",
                  [
                    _c("el-col", [
                      _c("p", [
                        _c("span", { staticStyle: { "font-weight": "bold" } }, [
                          _vm._v("Sektoren Vorschau Stil (px)")
                        ]),
                        _vm._v(
                          ": oben -\n                        " +
                            _vm._s(_vm.building.fields_top_position) +
                            ", links - " +
                            _vm._s(_vm.building.fields_left_position) +
                            ", Sektor Breite -\n                        " +
                            _vm._s(_vm.building.field_width) +
                            ", Gebäude Breite - " +
                            _vm._s(_vm.building.building_width)
                        )
                      ])
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "building-details--image" }, [
                  _c("img", {
                    attrs: {
                      src:
                        _vm.buildingImageFileList.length > 0
                          ? _vm.buildingImageFileList[0].url
                          : _vm.building.image,
                      alt: "",
                      width: "200px"
                    }
                  })
                ])
              ],
              1
            )
      ]),
      _vm._v(" "),
      _c(
        "el-card",
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header"
            },
            [
              _c("span", [_vm._v("Modul Preis")]),
              _vm._v(" "),
              _vm.user_is_admin && _vm.priceEditMode
                ? _c(
                    "el-button",
                    {
                      staticStyle: { float: "right", padding: "3px 0" },
                      attrs: { type: "text" },
                      on: {
                        click: function($event) {
                          _vm.priceEditMode = !_vm.priceEditMode
                        }
                      }
                    },
                    [_vm._v("Abbrechen")]
                  )
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-row",
            [
              _vm.hasDefaultPrice
                ? _c("el-col", { attrs: { span: 12 } }, [
                    _c("p", [
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("Aktueller Modul Preis")
                      ]),
                      _vm._v(": " + _vm._s(_vm.building.default_panel_price))
                    ]),
                    _vm._v(" "),
                    _c("br")
                  ])
                : _vm._e(),
              _vm._v(" "),
              !_vm.noPrices
                ? _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c(
                        "el-table",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.building.prices,
                            border: "",
                            "default-sort": {
                              prop: "price_start_date",
                              order: "ascending"
                            }
                          }
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              "min-width": 63,
                              prop: "price_start_date",
                              label: "Datum",
                              sortable: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-input", {
                                        class: {
                                          bold:
                                            scope.row.id ===
                                            _vm.building.default_panel_price_id
                                        },
                                        attrs: {
                                          disabled: !scope.row.edited,
                                          id: "panel_" + scope.row.id
                                        },
                                        model: {
                                          value: scope.row.price_start_date,
                                          callback: function($$v) {
                                            _vm.$set(
                                              scope.row,
                                              "price_start_date",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "scope.row.price_start_date"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1221490057
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              "min-width": 63,
                              prop: "price",
                              label: "Preis",
                              sortable: ""
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c("el-input", {
                                        class: {
                                          bold:
                                            scope.row.id ===
                                            _vm.building.default_panel_price_id
                                        },
                                        attrs: {
                                          disabled: !scope.row.edited,
                                          id: "panel_price_" + scope.row.id
                                        },
                                        model: {
                                          value: scope.row.price,
                                          callback: function($$v) {
                                            _vm.$set(scope.row, "price", $$v)
                                          },
                                          expression: "scope.row.price"
                                        }
                                      })
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              1547859151
                            )
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "Aktion" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(scope) {
                                    return [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled: !scope.row.edited,
                                            type: "default"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleSaveRow(
                                                scope.$index,
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Speichern\n                            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled:
                                              scope.row.id ===
                                              _vm.building
                                                .default_panel_price_id,
                                            type: "primary"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleEditRow(
                                                scope.$index
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Bearbeiten\n                            "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            disabled:
                                              scope.row.id ===
                                              _vm.building
                                                .default_panel_price_id,
                                            type: "danger"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.handleDeleteRow(
                                                scope.$index,
                                                scope.row
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                                Löschen\n                            "
                                          )
                                        ]
                                      )
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              3932477391
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("br")
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-col",
                [
                  _c("el-col", { attrs: { span: 12 } }, [
                    _c("p", [
                      _c("span", { staticStyle: { "font-weight": "bold" } }, [
                        _vm._v("Neuer Modul Preis")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("br")
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "el-col el-col-24" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "el-table el-table--fit el-table--border el-table--enable-row-hover el-table--enable-row-transition",
                        staticStyle: { width: "100%" }
                      },
                      [
                        _c("div", { staticClass: "el-table__header-wrapper" }, [
                          _c(
                            "table",
                            {
                              staticClass: "el-table__header",
                              staticStyle: { width: "1097px" },
                              attrs: {
                                cellspacing: "0",
                                cellpadding: "0",
                                border: "0"
                              }
                            },
                            [
                              _c("colgroup", [
                                _c("col", {
                                  attrs: {
                                    name: "el-table_7_column_40",
                                    width: "336"
                                  }
                                }),
                                _vm._v(" "),
                                _c("col", {
                                  attrs: {
                                    name: "el-table_7_column_41",
                                    width: "335"
                                  }
                                }),
                                _vm._v(" "),
                                _c("col", {
                                  attrs: {
                                    name: "el-table_7_column_42",
                                    width: "426"
                                  }
                                }),
                                _vm._v(" "),
                                _c("col", {
                                  attrs: { name: "gutter", width: "0" }
                                })
                              ]),
                              _vm._v(" "),
                              _c("thead", { staticClass: "has-gutter" }, [
                                _c("tr", {}, [
                                  _c(
                                    "th",
                                    {
                                      staticClass: "is-leaf",
                                      attrs: { colspan: "1", rowspan: "1" }
                                    },
                                    [
                                      _c("div", { staticClass: "cell" }, [
                                        _vm._v(
                                          "\n                                                Neues Datum\n                                            "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticClass: "is-leaf",
                                      attrs: { colspan: "1", rowspan: "1" }
                                    },
                                    [
                                      _c("div", { staticClass: "cell" }, [
                                        _vm._v(
                                          "\n                                                Neuer Preis\n                                            "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "th",
                                    {
                                      staticClass: "is-leaf",
                                      attrs: { colspan: "1", rowspan: "1" }
                                    },
                                    [
                                      _c("div", { staticClass: "cell" }, [
                                        _vm._v(
                                          "\n                                                Aktion\n                                            "
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c("th", {
                                    staticClass: "gutter",
                                    staticStyle: {
                                      width: "0px",
                                      display: "none"
                                    }
                                  })
                                ])
                              ])
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "el-table__body-wrapper is-scrolling-none"
                          },
                          [
                            _c(
                              "table",
                              {
                                staticClass: "el-table__body",
                                staticStyle: { width: "1097px" },
                                attrs: {
                                  cellspacing: "0",
                                  cellpadding: "0",
                                  border: "0"
                                }
                              },
                              [
                                _c("colgroup", [
                                  _c("col", {
                                    attrs: {
                                      name: "el-table_7_column_40",
                                      width: "336"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("col", {
                                    attrs: {
                                      name: "el-table_7_column_41",
                                      width: "335"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("col", {
                                    attrs: {
                                      name: "el-table_7_column_42",
                                      width: "426"
                                    }
                                  })
                                ]),
                                _vm._v(" "),
                                _c("tbody", [
                                  _c("tr", { staticClass: "el-table__row" }, [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "el-table_7_column_40",
                                        attrs: { rowspan: "1", colspan: "1" }
                                      },
                                      [
                                        _c("div", { staticClass: "cell" }, [
                                          _c(
                                            "div",
                                            { staticClass: "el-input" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.newPanelDate,
                                                    expression: "newPanelDate"
                                                  }
                                                ],
                                                staticClass: "el-input__inner",
                                                attrs: {
                                                  type: "text",
                                                  autocomplete: "off",
                                                  id: "new_panel_date"
                                                },
                                                domProps: {
                                                  value: _vm.newPanelDate
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.newPanelDate =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "el-table_7_column_41",
                                        attrs: { rowspan: "1", colspan: "1" }
                                      },
                                      [
                                        _c("div", { staticClass: "cell" }, [
                                          _c(
                                            "div",
                                            { staticClass: "el-input" },
                                            [
                                              _c("input", {
                                                directives: [
                                                  {
                                                    name: "model",
                                                    rawName: "v-model",
                                                    value: _vm.newPanelPrice,
                                                    expression: "newPanelPrice"
                                                  }
                                                ],
                                                staticClass: "el-input__inner",
                                                attrs: {
                                                  type: "text",
                                                  autocomplete: "off",
                                                  id: "new_panel_price"
                                                },
                                                domProps: {
                                                  value: _vm.newPanelPrice
                                                },
                                                on: {
                                                  input: function($event) {
                                                    if (
                                                      $event.target.composing
                                                    ) {
                                                      return
                                                    }
                                                    _vm.newPanelPrice =
                                                      $event.target.value
                                                  }
                                                }
                                              })
                                            ]
                                          )
                                        ])
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "td",
                                      {
                                        staticClass: "el-table_7_column_42",
                                        attrs: { rowspan: "1", colspan: "1" }
                                      },
                                      [
                                        _c("div", { staticClass: "cell" }, [
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "el-button el-button--default",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function($event) {
                                                  return _vm.uploadPriceSingleNew(
                                                    {
                                                      price_start_date:
                                                        _vm.newPanelDate,
                                                      price: _vm.newPanelPrice
                                                    }
                                                  )
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                                        Speichern\n                                                    "
                                                )
                                              ])
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "button",
                                            {
                                              staticClass:
                                                "el-button el-button--danger",
                                              attrs: { type: "button" },
                                              on: { click: _vm.clearNewPanel }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  "\n                                                        Löschen\n                                                    "
                                                )
                                              ])
                                            ]
                                          )
                                        ])
                                      ]
                                    )
                                  ])
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "el-table__column-resize-proxy",
                          staticStyle: { display: "none" }
                        })
                      ]
                    ),
                    _vm._v(" "),
                    _c("br")
                  ]),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  _vm.hasDefaultPrice && !_vm.priceEditMode
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: {
                            click: function($event) {
                              _vm.priceEditMode = !_vm.priceEditMode
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n                    Neue Preise als CSV-Datei importieren\n                "
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              !_vm.hasDefaultPrice || _vm.priceEditMode
                ? _c("el-col", [
                    _c(
                      "p",
                      [
                        _vm._v(
                          "\n                    Dieser Import überschreibt alle Preise der obigen Tabelle."
                        ),
                        _c("br"),
                        _vm._v(
                          "\n                    Sie können als Erstes die\n                    "
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: { click: _vm.downloadPanelPrices }
                          },
                          [
                            _vm._v(
                              "\n                        aktuellen Preise herunterladen.\n                    "
                            )
                          ]
                        ),
                        _vm._v(
                          "\n                    Und anschliessend die Preise in der Datei anpassen und hier wieder importieren.\n                "
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("p", [
                      _vm._v(
                        "Folgend ein Beispiel einer korrekten Preis-Datei:"
                      )
                    ]),
                    _c("br"),
                    _vm._v(" "),
                    _c("pre", { staticClass: "code-highlight box" }, [
                      _vm._v(
                        "2019-08-20;135\n2019-09-01;235\n2019-10-10;345\n                    "
                      )
                    ]),
                    _vm._v(" "),
                    _c("br")
                  ])
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          !_vm.hasDefaultPrice || _vm.priceEditMode
            ? _c(
                "el-row",
                { attrs: { gutter: 50 } },
                [
                  _c("br"),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-upload",
                        {
                          ref: "upload",
                          staticClass: "upload-demo",
                          attrs: {
                            name: "prices",
                            action: _vm.getUploadPriceUrl(),
                            "on-change": _vm.priceUploadChangeHandler,
                            "http-request": _vm.uploadPrice,
                            disabled: _vm.formSubmitted || !this.building.id,
                            "auto-upload": false
                          }
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: {
                                slot: "trigger",
                                type: "primary",
                                disabled: !this.building.id
                              },
                              slot: "trigger"
                            },
                            [
                              _vm._v(
                                "\n                        Datei auswählen und hochladen\n                        "
                              ),
                              _vm.formSubmitted
                                ? _c("i", { staticClass: "el-icon-loading" })
                                : _vm._e()
                            ]
                          ),
                          _vm._v(" "),
                          !this.building.id
                            ? _c(
                                "div",
                                {
                                  staticClass: "el-upload__tip",
                                  attrs: { slot: "tip" },
                                  slot: "tip"
                                },
                                [_vm._v("Gebäude als Erstes speichern")]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "warning" },
                          on: { click: _vm.downloadPanelPrices }
                        },
                        [
                          _vm._v(
                            "\n                    Preise als CSV-Datei exportieren\n                "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 4 } },
                    [
                      _vm.priceEditMode
                        ? _c(
                            "el-button",
                            {
                              on: {
                                click: function($event) {
                                  _vm.priceEditMode = !_vm.priceEditMode
                                }
                              }
                            },
                            [_vm._v("Abbrechen")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasDefaultPrice
        ? _c(
            "el-card",
            { attrs: { shadow: "always" } },
            [
              _c(
                "div",
                {
                  staticClass: "clearfix",
                  attrs: { slot: "header" },
                  slot: "header"
                },
                [
                  _c("span", [_vm._v("Sektoren")]),
                  _vm._v(" "),
                  _vm.user_is_admin
                    ? _c(
                        "el-button",
                        {
                          staticStyle: { float: "right", padding: "3px 0" },
                          attrs: { type: "text" },
                          on: {
                            click: function($event) {
                              _vm.showFieldForm = true
                            }
                          }
                        },
                        [_vm._v("Sektor hinzufügen")]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-row",
                { attrs: { type: "flex", justify: "space-between" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _vm._v(
                        "\n                Total Sektoren\n                "
                      ),
                      _c("el-tag", { attrs: { size: "small" } }, [
                        _vm._v(
                          _vm._s(
                            _vm.get_building(_vm.building.id).fields.length
                          )
                        )
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    {
                      staticStyle: { "text-align": "right" },
                      attrs: { span: 8 }
                    },
                    [
                      _vm._v(
                        "\n                Verfügbare Einheiten\n                "
                      ),
                      _c(
                        "el-tag",
                        { attrs: { size: "small", type: "success" } },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.get_building(_vm.building.id)
                                .total_available_panels
                            )
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("el-tag", { attrs: { size: "small" } }, [
                        _vm._v(
                          _vm._s(_vm.get_building(_vm.building.id).total_panels)
                        )
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-row"),
              _vm._v(" "),
              _vm.building.fields.length > 0
                ? _c(
                    "el-row",
                    { attrs: { gutter: 20 } },
                    _vm._l(_vm.get_building(_vm.building.id).fields, function(
                      field,
                      index
                    ) {
                      return _c(
                        "el-col",
                        { key: field.id, attrs: { span: 4 } },
                        [
                          _c(
                            "el-card",
                            {
                              staticClass: "field-box",
                              attrs: { shadow: "always" }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "clearfix",
                                  attrs: { slot: "header" },
                                  slot: "header"
                                },
                                [
                                  _vm.user_is_admin
                                    ? _c("DeleteBtn", {
                                        staticStyle: {
                                          float: "right",
                                          "margin-left": "1rem"
                                        },
                                        on: {
                                          clicked: function($event) {
                                            return _vm.deleteClickHandler(field)
                                          }
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "router-link",
                                    {
                                      attrs: {
                                        to: {
                                          name: "sector",
                                          params: {
                                            buildingId: _vm.building.id,
                                            fieldId: field.id,
                                            fieldIndex: index + 1
                                          }
                                        }
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(
                                          "Sektor " + _vm._s(field.field_number)
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "router-link",
                                {
                                  attrs: {
                                    to: {
                                      name: "sector",
                                      params: {
                                        buildingId: _vm.building.id,
                                        fieldId: field.id,
                                        fieldIndex: index + 1
                                      }
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "div",
                                    { staticStyle: { height: "150px" } },
                                    [
                                      _c("p", [
                                        _vm._v(
                                          "\n                                Einheiten\n                                "
                                        ),
                                        _c(
                                          "span",
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticStyle: { float: "right" },
                                                attrs: { size: "small" }
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(field.number_of_panels)
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("br"),
                                      _vm._v(" "),
                                      _c("p", [
                                        _vm._v(
                                          "Verfügbar\n                                "
                                        ),
                                        _c(
                                          "span",
                                          [
                                            _c(
                                              "el-tag",
                                              {
                                                staticStyle: { float: "right" },
                                                attrs: {
                                                  type: "success",
                                                  size: "small"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                        " +
                                                    _vm._s(
                                                      field.available_panels
                                                    )
                                                )
                                              ]
                                            )
                                          ],
                                          1
                                        )
                                      ])
                                    ]
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    }),
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6db08b5f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6db08b5f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/pages/buildings/building.html
// module id = null
// module chunks = 